export const AppBackdrop = () => (
  <div aria-hidden className="ax-backdrop" data-testid="app-backdrop">
    <span className="ax-orb ax-orb-a" />
    <span className="ax-orb ax-orb-b" />
    <span className="ax-orb ax-orb-c" />
    <span className="ax-grain" />
  </div>
);
